import { ModoConfirmacao } from "./../models/ModoConfirmacao.model";
import { AtividadeUsuarioService } from "./../services/atividade-usuario.service";
import { AuthService } from "./../services/auth.service";
import { ModalPedidoComponent } from "./../modal-pedido/modal-pedido.component";
import { Pedido, StatusPedido, TStatusPedido } from "./../models/pedido";
import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { CdkDragDrop, CdkDragEnd, moveItemInArray, transferArrayItem, CdkDragPlaceholder, CdkDragEnter, CdkDragExit } from "@angular/cdk/drag-drop";
import { Order } from "../models/order";
import { PedidoService } from "./../services/pedido.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MatDialog } from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
import { MenuService, NavItemsId } from "../services/menu.service";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { SnackbarService } from "./../services/snackbar.service";
import { DialogService } from "../services/dialog.service";
import { AppService } from "../services/app.service";
import { KanbanService } from "../services/kanban.service";
import { KanbanGrupo } from "../kanbam/KanbamGrupo";
import { EventService } from "../services/event.service";
import { KanbanPedido } from "../kanbam/KanbamPedido";
import { MatSelectChange } from "@angular/material/select";
import { NotificacaoService } from "../services/notificacao.service";

@Component({
  selector: "app-kanban-view",
  templateUrl: "./kanban-view.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./kanban-view.component.scss"],
})
export class KanbanViewComponent implements OnInit, OnDestroy {
  order = {} as Order;
  busca: FormGroup;
  timerAtualizacaoPedidos: any;
  timerAtualizacaoTempoPedido: any;
  urlImpressaoPedido: string;
  exibirPesquisa = false;

  mouseDown$ = new Subject<any>();
  mouseUp$ = new Subject<any>();

  coluna = {
    pendente: new Array<Pedido>(),
    producao: new Array<Pedido>(),
    entregando: new Array<Pedido>(),
    finalizado: new Array<Pedido>(),
    cancelados: new Array<Pedido>(),
    agendado: new Array<Pedido>(),
  };

  constructor(
    public pedidoService: PedidoService,
    private dialog: MatDialog,
    private authService: AuthService,
    private atividadeUsuario: AtividadeUsuarioService,
    private menuService: MenuService,
    private snackbarService: SnackbarService,
    private dialogService: DialogService,
    public appService: AppService,
    public kanbanService: KanbanService,
    private eventService: EventService,
    private changeDetector: ChangeDetectorRef,
    private notificacaoService: NotificacaoService
  ) { }

  ngOnInit() {
    this.menuService.menuAtivo = NavItemsId.PEDIDOS;
    if (this.authService.usuarioEstaLogado && !!this.pedidoService.orders) {
      // this.pedidoService.getPedidos();
    }

    this.eventService.aposMoverItemKanban$.subscribe(() => {
      this.changeDetector.detectChanges();
    })
  }

  ngOnDestroy() {
    this.pedidoService.pedidosSubject = new Subject();
    this.pedidoService.novosPedidosSubject = new Subject();
  }

  toogleExibirPesquisa() {
    this.exibirPesquisa = !this.exibirPesquisa;

    if (!this.exibirPesquisa) {
      this.pedidoService.filtroBusca = "";
    }
  }

  onClickKanbanCard(event: PointerEvent) {
    const eventTarget: Element = event.target as Element;
    const element = eventTarget.closest("[cdkdrag]");
    element.classList.remove("moving-enabled");
  }


  onMouseUpKanbanCard(event: PointerEvent) {
    const eventTarget: Element = event.target as Element;
    const element = eventTarget.closest("[cdkdrag]");
    element.classList.remove("moving-enabled");
  }

  onTouchEndKanbanCard(event: PointerEvent) {
    const eventTarget: Element = event.target as Element;
    const element = eventTarget.closest("[cdkdrag]");
    element.classList.remove("moving-enabled");
  }

  cdkDragEnded($event: CdkDragEnd, grupo) {
    $event.source.element.nativeElement.classList.remove("moving-enabled");
  }

  onCdkDropListDropped(event: CdkDragDrop<KanbanGrupo>) {
    event.container.data.desativarDestaqueDaLista();
  }

  onDropListEntered(event: CdkDragEnter<KanbanGrupo>, grupo: KanbanGrupo) {
    event.container.data.ativarDestaqueDaLista();
  }

  onDropListExited(event: CdkDragExit<KanbanGrupo>, grupo: KanbanGrupo) {
    event.container.data.desativarDestaqueDaLista();
  }

  mouseLongPress(targetElement: any) {
    const canVibrate = !!window.navigator?.vibrate ?? false;
    if (canVibrate) window.navigator.vibrate(100);

    const element = targetElement.classList.contains('cdk-drag')
      ? targetElement
      : targetElement.closest(".cdk-drag");

      console.log(element, "certinho.");

    element.classList.add("moving-enabled");
  }

  cdkDragReleased(event: any) {
  }

  cdkDragStarted(event: any) {
  }

  mapearPedidos(orders: Pedido[]) {
    this.coluna.pendente = orders.filter((item) => Number(item.status) === 1);

    this.coluna.producao = orders.filter((item) => Number(item.status) === 2);

    this.coluna.entregando = orders.filter((item) => Number(item.status) === 3);

    this.coluna.finalizado = orders.filter((item) => Number(item.status) === 4);

    this.coluna.cancelados = orders.filter((item) => Number(item.status) === 5);

    this.coluna.agendado = orders
      .filter((item) => Number(item.status) === 6)
      .map((item) => {
        const TimestampAgendamento = this.pedidoService.getTimestampDataAgendamentoPedido(item);
        return {
          ...item,
          TimestampAgendamento,
        };
      })
      .sort((a, b) => a?.TimestampAgendamento - b?.TimestampAgendamento);
  }

  get orders() {
    return this.pedidoService.orders;
  }

  trackByItem = (index: number, item: any) => {
    return item.pedido.id;
  }

  trackByColumn = (index: number, item: any) => {
    return item.numeroDoStatus;
  }

  get exibirOpcoesDaColuna() {
    return !this.pedidoService?.filtroBusca && !this.kanbanService.temAlgumFiltroAtivo;
  }

  cancelarPedido(pedido: KanbanPedido, statusAnterior: number) {
    this.dialogService
      .confirm("Confirmação", "Confirma o cancelamento do pedido?")
      .then(() => {
        this.kanbanService.movimentarItemAutomaticamente(pedido, statusAnterior, Number(StatusPedido.CANCELADO));
      })
      .catch((error) => { });
  }

  limparGrupo(grupo: KanbanGrupo) {
    this.dialogService
      .confirm(
        "Confirmação",
        "Todos os pedidos desta coluna serão limpos.<br><br><b>Deseja confirmar?</b>"
      )
      .then(() => {
        this.kanbanService.limparGrupo(grupo);
      })
      .catch((error) => { });
  }

  limparMonitor() {
    this.dialogService
      .confirm(
        "Confirmação",
        "O monitor será limpo. Todos os pedidos não serão mais vistos neste terminal<br><br><b>Deseja confirmar?</b>"
      )
      .then(() => {
        this.kanbanService.limparMonitor();
      })
      .catch((error) => { });
  }

  getPedidosDoDia() {
    this.dialogService
      .confirm(
        "Confirmação",
        "Todos e somente os pedidos do dia serão exibidos no monitor.<br><br><b>Deseja confirmar?</b>"
      )
      .then(() => {
        this.kanbanService.exibirSomentePedidosDoDia();
      })
      .catch((error) => { });
  }

  afterDropEvent(event: CdkDragDrop<KanbanGrupo>) {
    this.kanbanService.movimentarItemManualmente(event).catch((erro: string) => {
      this.snackbarService.Error(erro);
    });
  }

  visualizarPedido(pedidoKanban: KanbanPedido) {
    const order = pedidoKanban.pedido;
    order.NomeLoja = this.authService?.usuario?.NomeLoja ?? null;
    this.updateAtividade();
    this.dialog.open(ModalPedidoComponent, {
      data: {
        Hash: order.Hash,
        Pedido: order
      },
      backdropClass: "view-pedido"
    });
  }

  imprimirPedido(order: Pedido) {
    order.NomeLoja = this.authService.usuario.NomeLoja;
    this.updateAtividade();
    this.dialog.open(ModalPedidoComponent, {
      data: {
        Hash: order.Hash,
        Imprimir: true,
        Pedido: order
      },
      backdropClass: "view-pedido"
    });
  }

  chamarNumero(kanbanPedido: KanbanPedido) {
    this.updateAtividade();
    const order = kanbanPedido.pedido;
    let mensagem = "";
    const endUrl = "&text=Ol%C3%A1%2C%20" + order.Pedido.Nome + "!";
    const entrega = order.Pedido.OpcaoEntrega;
    const pedidoStatus = String(order.status);

    switch (pedidoStatus) {
      case "1":
        mensagem = "%20Recebemos%20seu%20pedido%2C%20enviaremos%20por%20aqui%20futuras%20atualizações";
        break;
      case "2":
        mensagem = " Seu pedido foi confirmado e já está sendo preparado.";
        break;
      case "3":
        switch (entrega) {
          case "E":
            mensagem = " Seu pedido foi finalizado e já saiu para entrega.";
            break;
          case "R":
            mensagem = " Seu pedido foi finalizado e já pode ser retirado.";
            break;
          case "L":
            break;
        }
        break;

      case "4":
        mensagem = " Seu pedido foi finalizado! Aproveite sua refeição%20%F0%9F%98%81";
        break;
      case "5":
        break;
    }

    const celular = "+55" + order.Pedido.Celular;
    const link = `https://wa.me/${celular}/?text=${mensagem}`;

    window.open(link);
  }

  updateAtividade() {
    this.atividadeUsuario.registrar();
  }

  get filtroExibicao() {
    return this.pedidoService.filtroExibicao;
  }
}
